<template>
  <global-modal
    :active="dialog.isActive"
    @toggleActive="toggleActive"
    classModal="w-full sm:w-3/5"
  >
    <!-- Title -->
    <section class="text-xl font-medium" slot="header">Update Avatar Pengguna</section>

    <!-- Body -->
    <div class="w-full p-5">
      <!-- List current files -->
      <ul>
        <global-file-upload
          v-for="(item, index) in dialog.files"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              radius
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              @click="handleOnRemove({ id: item.id, index })"
            ></vs-button>
          </template>
        </global-file-upload>
        <!-- Action -->
      </ul>

      <!-- Upload new files -->
      <vs-upload @change="handleOnFileChange" ref="upload" :singleUpload="1" :limit="1" />
    </div>

    <!-- Footer -->
    <section class="p-4 flex justify-end" slot="footer">
      <div>
        <vs-button
          id="confirmAccept"
          class="mx-1"
          color="primary"
          type="filled"
          @click="handleOnSubmit"
        >
          Update
        </vs-button>
        <vs-button
          id="confirmCancel"
          class="mx-1"
          color="danger"
          type="border"
          @click="handleOnCancel"
        >
          Cancel
        </vs-button>
      </div>
    </section>
  </global-modal>
</template>

<script>
import { digofHttp as axios } from "@/axios";
export default {
  props: {
    penggunaId: {
      type: [Number, String],
      required: true
    },
    dokumen: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      dialog: {
        isActive: false,
        files: []
      },
      formValues: {
        files: [],
        removeIds: []
      }
    };
  },

  methods: {
    initDialogValues() {
      this.dialog.files = [...this.dokumen];
    },

    async handleOnSubmit() {
      try {
        await this.postDocuments();
        this.toggleActive(false);
        this.submitCallback();
        this.$vs.notify({
          title: "Sukses",
          text: "Update Avatar Pengguna Berhasil",
          color: "success"
        });
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Gagal",
          text: "Update Avatar Pengguna Gagal",
          color: "danger"
        });
      }
    },

    handleOnCancel() {
      this.toggleActive(false);
    },

    handleOnRemove({ id, index }) {
      this.formValues.removeIds.push(id);
      this.dialog.files.splice(index, 1);
    },

    handleOnFileChange() {
      const files = this.$refs.upload.filesx;
      if (!files.length) return;
      this.formValues.files = files;
    },

    submitCallback() {
      this.$emit("submitCallback", true);
    },

    toggleActive(isActive) {
      this.dialog.isActive = isActive;
      this.initDialogValues();
      this.resetFormValues();
    },

    async postDocuments() {
      const response = await axios({
        url: "pengguna/file-upload",
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: this.getFormDataPayload()
      });
      const data = await response.data;
      return data;
    },

    getFormDataPayload() {
      const formData = new FormData();
      formData.append("pengguna_id", this.penggunaId);
      formData.append("file_type", 'avatar');
      this.formValues.files.forEach(file => {
        return formData.append("files", file);
      });
      return formData;
    },

    resetFormValues() {
      this.formValues.files = [];
      this.formValues.removeIds = [];
    }
  }
};
</script>
